import { apiClient } from '../client'
import type { ApiResponse } from '../client.types'
import type { TonStartAuthResponse, TonVerifyRequest, UserRead } from '../types'

/**
 * Authentication API endpoints
 * POST /auth/ton/start - Start TON authentication
 * POST /auth/ton/verify - Verify TON proof
 * GET /auth/users/me - Get current user
 */

export const authApi = {
  /**
   * Start TON authentication - get payload token and hash
   * POST /auth/ton/start
   */
  startTONAuth(): Promise<ApiResponse<TonStartAuthResponse>> {
    return apiClient.post<TonStartAuthResponse>('/auth/ton/start')
  },

  /**
   * Verify TON authentication - send proof and get user data
   * POST /auth/ton/verify
   */
  verifyTONAuth(request: TonVerifyRequest): Promise<ApiResponse<UserRead>> {
    return apiClient.post<UserRead>('/auth/ton/verify', request)
  },

  /**
   * Get current authenticated user data
   * GET /auth/users/me
   */
  getCurrentUser(): Promise<ApiResponse<UserRead>> {
    return apiClient.get<UserRead>('/auth/users/me')
  },
}
